import { Fragment, memo, useRef } from 'react'
import { useSelector } from 'react-redux'
import { tileEntityAllIdsSelector } from '~/app/store/tileEntity'
import { currentPageSelector, totalEntityCountSelector } from '~/app/store/paging'
import { CareTile } from '~/app/features/Gallery/components/PreviewArea/CareTile'
import { currentPageInfoSelector, loadMoreCountSelector } from '~/app/store/paging/selectors'
import { DesignTileWrapper } from '~/app/features/Gallery/components/PreviewArea/DesignTileWrapper'
import { getIsLoadMoreAvailable } from '~/app/store/config/selectors'
import { useColorSwatchResizeObserve } from '~/app/features/Gallery/hooks/useColorSwatchResizeObserve'
import { THREE_DIFY_TILE_POSITIONS } from '~/app/features/Gallery/components/PreviewArea/constants'
import { shouldHideCareTileSelector } from '~/app/store/refinement/selectors'

const DesignTilesListComponent = () => {
  const resultCount = useSelector(totalEntityCountSelector)
  const tileEntityIds = useSelector(tileEntityAllIdsSelector)
  const currentPage = useSelector(currentPageSelector)
  const isLoadMoreAvailable = useSelector(getIsLoadMoreAvailable)
  const loadMoreCount = useSelector(loadMoreCountSelector)
  const shouldHideCareTile = useSelector(shouldHideCareTileSelector)
  const { pageSize } = useSelector(currentPageInfoSelector)
  const gridRef = useRef<HTMLDivElement>(null!)
  const maxColorSwatchesPerRow = useColorSwatchResizeObserve(gridRef)

  const isFirstPage = currentPage === 1

  const isFirstPageAndTemplatesExist = isFirstPage && resultCount > 0
  const shouldShowCareTile = isFirstPageAndTemplatesExist && !shouldHideCareTile && !(tileEntityIds.length < pageSize)

  const calculateCareTilePosition = (index: number): boolean => {
    if (!shouldShowCareTile) {
      return false
    }

    if (isLoadMoreAvailable) {
      return THREE_DIFY_TILE_POSITIONS.includes(index)
    }

    return (THREE_DIFY_TILE_POSITIONS.indexOf(index) > -1 && THREE_DIFY_TILE_POSITIONS.indexOf(index) < loadMoreCount) || tileEntityIds.length === index + 1
  }

  return (
    <>
      {tileEntityIds.map((entityId: string, index: number) => {
        const shouldPinCareTile = calculateCareTilePosition(index)

        const refValue = index === 0 ? gridRef : null

        return (
          <Fragment key={entityId}>
            <li className="design-tile-wrapper" data-testid="design-tile">
              <DesignTileWrapper entityId={entityId} maxColorSwatchesPerRow={maxColorSwatchesPerRow} refValue={refValue} />
            </li>
            {shouldPinCareTile && <CareTile />}
          </Fragment>
        )
      })}
    </>
  )
}

export const DesignTilesList = memo(DesignTilesListComponent)
